<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <ItpBox
    alignItems="center"
    class="mb-2"
  >
    <strong>
      {{ 'Invoices'|pgettext('Payment') }}
    </strong>
    <ItpButton
      :icon="$config.addIcon"
      :text="'Add invoice...'|pgettext('Payment')"
      size="sm"
      variant="light"
      class="mx-4"
      v-if="!payment.isReadonly"
      @click="evh_3343864469950044_click($event, {})"
    >
    </ItpButton>
    <DIV
      :title="'Invoice amount mismatch'|pgettext('Payment')"
      class="pb-2 text-nowrap"
      v-if="invoiceTotalsDiff"
    >
      <Icon
        icon="emojione-v1:warning"
      >
      </Icon>
      <ItpText
        :text="'Mismatch between the amount of payment and invoices.'|pgettext('payment')"
        class="text-wrap"
      >
      </ItpText>
    </DIV>
  </ItpBox>
  <ItpDataTable
    rowKeyField="invoice_id"
    tableId="paymentInvoices"
    :paging="b_5962862420439144_paging"
    :editable="!payment.isReadonly"
    :sortable="b_5962862420439144_sortable"
    :globs="messages"
    :value="payment.invoices.data"
    no-create-row
    no-confirm-delete-row
    footer-totals
    :columns="b_5962862420439144_columns"
    v-if="payment.invoices.data"
    @save-completed="evh_5962862420439144_saveCompleted($event, {})"
    @delete="evh_5962862420439144_delete($event, {})"
    @delete-completed="evh_5962862420439144_deleteCompleted($event, {})"
  >
  </ItpDataTable>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcPaymentInvoices extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  createInvoicePaymentData(...args: any[]) {
    const [data] = args;
    return {
      invoice_id: data.id,
      invoice_number: data.invoice_number,
      currency: data.currency,
      amount: data.outstanding_amounts,
      exchange_rate: 1,
      client: data.client,
      invoice: data
    };
  }

  @Prop({
    required: true,
    type: Object,
  })
  payment!: object;

  @Watch('payment')
  onPayment(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("payment")
  }

  messages!: any;
  ux!: any;
  b_5962862420439144_paging!: any;
  b_5962862420439144_sortable!: any;
  b_5962862420439144_columns!: any;
  dataMembers = ['messages', 'ux', 'b_5962862420439144_paging', 'b_5962862420439144_sortable', 'b_5962862420439144_columns'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        messages: {
          grossAmount: this.$fn.pgettext("Invoice", "Gross amount"),
          paidAmount: this.$fn.pgettext("Invoice", "Payments"),
          noPaymentRequired: this.$fn.pgettext("Invoice", "No payment required"),
        }
        ,
        ux: null,
        b_5962862420439144_paging: false,
        b_5962862420439144_sortable: false,
        b_5962862420439144_columns: [{
          name: "invoice_number",
          width: "310px",
          header: this.$fn.pgettext("InvoicePayment", "Invoice"),
          readonly: true,
          textAlign: "left",
          type: "template",
          value: "<DIV>\n\
  <UcInvoiceBadge :value=\"row.invoice\"></UcInvoiceBadge>\n\
\n\
  <div>\n\
    {{ row.invoice.invoice_date || date }}\n\
  </div>\n\
\n\
  <div>\n\
    <ItpText>{{ globs.grossAmount }}:</ItpText>\n\
    <strong>{{ row.invoice.total_amount | number }} {{ row.invoice.currency }}</strong><br/>\n\
  </div>\n\
\n\
  <div v-if=\"row.invoice.total_payment\">\n\
    <ItpText>{{ globs.paidAmount }}:</ItpText>\n\
    <strong>{{ row.invoice.total_payment | number }} {{ row.invoice.currency }}</strong><br/>\n\
  </div>\n\
  <UcCompanyMiniCard :item=\"row.invoice.client\" no-link></UcCompanyMiniCard>\n\
</DIV>\n\
",
        }
          ,
        {
          name: "amount",
          header: this.$fn.pgettext("InvoicePayment", "Amount"),
          type: "number",
          width: "110px",
          textAlign: "right",
          required: true,
        }
          ,
        {
          name: "exchange_rate",
          width: "70px",
          header: this.$fn.pgettext("InvoicePayment", "Exch. Rate"),
          type: "number",
          textAlign: "right",
          required: true,
          noFooterTotals: true,
        }
          ,
        {
          name: "notes",
          width: "210px",
          header: this.$fn.pgettext("InvoicePayment", "Notes"),
        }
          ,
        ]
        ,
      },
    }
  }

  get invoiceTotals() {
    if (this.loaded) {

      return _.isEmpty(this.payment.invoices && this.payment.invoices.data) ? null : _.chain(this.payment.invoices.data)
        .reduce(
          (sum, v, k) => (sum.add(v.amount), sum),
          this.$fn.numeral(0)
        )
        .value()
    }
    return null;
  }

  get invoiceTotalsDiff() {
    if (this.loaded) {

      return this.invoiceTotals != null
        ? this.$fn.numeral(this.payment.amount).difference(this.invoiceTotals.value())
        : null
    }
    return null;
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  async act_3343864469950044_script_7882_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_3343864469950044_script_7882, alias=undefined
    (
      console.log($event),

      _.chain($event.data.modalResult.value)
        .map(this.createInvoicePaymentData)
        .filter(p => !_.some(this.payment.invoices.data, { invoice_id: p.invoice_id }))
        .each(p => this.payment.invoices.data.push(p))
        .value()
    )
  }

  async act_3343864469950044_script_7882_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_3343864469950044_script_7882, alias=undefined
    return {
      value: () => this.act_3343864469950044_script_7882_getActionArgs_value($event),
    }
  }

  async evh_3343864469950044_close_7881_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_3343864469950044_close_7881, alias=undefined
    return $event.data.modalResult.ok
  }

  async act_3343864469950044_emit_7884_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_3343864469950044_emit_7884, alias=undefined
    return {
      event: "recalculate",
    }
  }

  async evh_3343864469950044_close_7883_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_3343864469950044_close_7883, alias=undefined
    return $event.data.modalResult.ok
  }

  async act_3343864469950044_showModal_7880_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_3343864469950044_showModal_7880, alias=addInvoice
    return {
      name: "InvoiceBrowser",
      props: {
        size: "full-screen",
        company_id: this.payment.account && this.payment.account.owner.id,
        client_id: this.payment.partner && this.payment.partner.id,
        multiselect: true,
      }
      ,
    }
  }

  async evh_3343864469950044_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3343864469950044_click.executeFromDOM(this, event, scope);
  }

  async act_5962862420439144_emit_7886_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_5962862420439144_emit_7886, alias=undefined
    return {
      event: "recalculate",
      value: $event.data.result,
    }
  }

  async evh_5962862420439144_saveCompleted(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5962862420439144_saveCompleted.executeFromDOM(this, event, scope);
  }

  async act_5962862420439144_script_7888_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_5962862420439144_script_7888, alias=undefined
    _.remove(this.payment.invoices.data, { invoice_id: $event.data.row.invoice_id })
  }

  async act_5962862420439144_script_7888_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_5962862420439144_script_7888, alias=undefined
    return {
      value: () => this.act_5962862420439144_script_7888_getActionArgs_value($event),
    }
  }

  async evh_5962862420439144_delete(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5962862420439144_delete.executeFromDOM(this, event, scope);
  }

  async act_5962862420439144_emit_7890_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_5962862420439144_emit_7890, alias=undefined
    return {
      event: "recalculate",
    }
  }

  async evh_5962862420439144_deleteCompleted(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5962862420439144_deleteCompleted.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_7878: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_7877: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
    act_3343864469950044_script_7882: actions.ScriptAction;
    evh_3343864469950044_close_7881: actions.EventHandlerImpl;
    act_3343864469950044_emit_7884: actions.EmitAction;
    evh_3343864469950044_close_7883: actions.EventHandlerImpl;
    act_3343864469950044_showModal_7880: actions.ShowModalAction;
    evh_3343864469950044_click_7879: actions.EventHandlerImpl;
    evh_3343864469950044_click: actions.EventHandlerGroup;
    act_5962862420439144_emit_7886: actions.EmitAction;
    evh_5962862420439144_saveCompleted_7885: actions.EventHandlerImpl;
    evh_5962862420439144_saveCompleted: actions.EventHandlerGroup;
    act_5962862420439144_script_7888: actions.ScriptAction;
    evh_5962862420439144_delete_7887: actions.EventHandlerImpl;
    evh_5962862420439144_delete: actions.EventHandlerGroup;
    act_5962862420439144_emit_7890: actions.EmitAction;
    evh_5962862420439144_deleteCompleted_7889: actions.EventHandlerImpl;
    evh_5962862420439144_deleteCompleted: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_7878 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_7877 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_7878,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_7877],
      }
    );
    const act_3343864469950044_script_7882 = new actions.ScriptAction(
      {
        actionArgs: this.act_3343864469950044_script_7882_getActionArgs,
        events: [],
      }
    );
    const evh_3343864469950044_close_7881 = new actions.EventHandlerImpl(
      {
        action: act_3343864469950044_script_7882,
        event: "close",
        when: this.evh_3343864469950044_close_7881_getWhen,
        displayName: "script",
      }
    );
    const act_3343864469950044_emit_7884 = new actions.EmitAction(
      {
        actionArgs: this.act_3343864469950044_emit_7884_getActionArgs,
        events: [],
      }
    );
    const evh_3343864469950044_close_7883 = new actions.EventHandlerImpl(
      {
        action: act_3343864469950044_emit_7884,
        event: "close",
        when: this.evh_3343864469950044_close_7883_getWhen,
        displayName: "emit",
      }
    );
    const act_3343864469950044_showModal_7880 = new actions.ShowModalAction(
      {
        actionArgs: this.act_3343864469950044_showModal_7880_getActionArgs,
        displayName: "addInvoice",
        events: [evh_3343864469950044_close_7881, evh_3343864469950044_close_7883],
      }
    );
    const evh_3343864469950044_click_7879 = new actions.EventHandlerImpl(
      {
        action: act_3343864469950044_showModal_7880,
        event: "click",
        displayName: "addInvoice",
      }
    );
    const evh_3343864469950044_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_3343864469950044_click_7879],
      }
    );
    const act_5962862420439144_emit_7886 = new actions.EmitAction(
      {
        actionArgs: this.act_5962862420439144_emit_7886_getActionArgs,
        events: [],
      }
    );
    const evh_5962862420439144_saveCompleted_7885 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_emit_7886,
        event: "save-completed",
        displayName: "emit",
      }
    );
    const evh_5962862420439144_saveCompleted = new actions.EventHandlerGroup(
      {
        handlers: [evh_5962862420439144_saveCompleted_7885],
      }
    );
    const act_5962862420439144_script_7888 = new actions.ScriptAction(
      {
        actionArgs: this.act_5962862420439144_script_7888_getActionArgs,
        events: [],
      }
    );
    const evh_5962862420439144_delete_7887 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_script_7888,
        event: "delete",
        displayName: "script",
      }
    );
    const evh_5962862420439144_delete = new actions.EventHandlerGroup(
      {
        handlers: [evh_5962862420439144_delete_7887],
      }
    );
    const act_5962862420439144_emit_7890 = new actions.EmitAction(
      {
        actionArgs: this.act_5962862420439144_emit_7890_getActionArgs,
        events: [],
      }
    );
    const evh_5962862420439144_deleteCompleted_7889 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_emit_7890,
        event: "delete-completed",
        displayName: "emit",
      }
    );
    const evh_5962862420439144_deleteCompleted = new actions.EventHandlerGroup(
      {
        handlers: [evh_5962862420439144_deleteCompleted_7889],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_7878,
      evh_7315092382398562_reload_7877,
      evh_7315092382398562_reload,
      act_3343864469950044_script_7882,
      evh_3343864469950044_close_7881,
      act_3343864469950044_emit_7884,
      evh_3343864469950044_close_7883,
      act_3343864469950044_showModal_7880,
      evh_3343864469950044_click_7879,
      evh_3343864469950044_click,
      act_5962862420439144_emit_7886,
      evh_5962862420439144_saveCompleted_7885,
      evh_5962862420439144_saveCompleted,
      act_5962862420439144_script_7888,
      evh_5962862420439144_delete_7887,
      evh_5962862420439144_delete,
      act_5962862420439144_emit_7890,
      evh_5962862420439144_deleteCompleted_7889,
      evh_5962862420439144_deleteCompleted,
      addInvoice: act_3343864469950044_showModal_7880,
    }
  }
}

Vue.component("UcPaymentInvoices", UcPaymentInvoices);

</script>